<script>
import displaySettings from "@/mixin/displaySettings";
import { SmartLink } from '@/shared/ui/link';
import { BlueButton } from '@/shared/ui/form';

export default {
  name: "QuotationPropositionDialog",
  components: { SmartLink, BlueButton },
  mixins: [displaySettings],
  data() {
    return {
      dialogVisible: false,
      propositionId: null,
      selectedPropositionStatus: false,
    };
  },
  computed: {
    isAlreadySelected() {
      return this.selectedPropositionStatus ?? false;
    }
  },
  methods: {
    reloadPage() {
      this.$emit('update:dialogVisible', false);
      //location.reload(false)
      this.$router.push({name: 'quotations'})
    },
    closeModal() {
      this.dialogVisible = false;
     // this.$emit('update:dialogVisible', false);
    },
    async show(propositionId, rowData = null, selectedPropositionId = null) {
      this.dialogVisible = true;
      this.propositionId = propositionId;
      this.selectedPropositionStatus = selectedPropositionId;
    }
  },
}
</script>

<template>
  <div class="quotation-success">
    <el-dialog
      :width="isMobile ? '100%' : '80%'"
      :visible.sync="dialogVisible"
      center
      top="30vh"
      :before-close="closeModal"
      custom-class="py-4"
    >
      <div slot="title">
        <div v-if="isAlreadySelected" class="title mb-2">Пропозицію вже обрано!</div>
        <div v-else class="title mb-2">Пропозиція №{{ propositionId }} успішно вибрана!</div>
      </div>
      <div class="description">
        Переобрати пропозицію неможливо
      </div>
      <div slot="footer">
        <el-row>
          <el-col>
            <el-button type="primary self-blue" class="w-100" @click="reloadPage">до Центру котирування</el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<style lang="scss">
@import "./styles/quotation-modal.scss";
</style>
